<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight" size="small"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getUseRateInfoUrl" @listData='getDeviceData'></MyPage>
		<!-- 	<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal> -->
	</div>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/UseRateInfoForm.vue';
	import webapi from '../../../../webapi.js';
	//	import infoModal from './Template/UseRateInfoModal.vue';
	export default {
		components: {
			searchForm,
			//infoModal
		},
		data() {
			return {
				getUseRateInfoUrl: webapi.base_api_url + '/Statistics/GetUseRateInfo',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: [this.$tt('统计分析'), '>>', this.$tt('利用率')],
				//table标题数据
				columns1: [{
						title: this.$tt('场站'),
						key: 'StationName',
					}, {
						title: this.$tt('运营商'),
						key: 'OperatorName',
					}, {
						title: this.$tt('利用率'),
						key: 'UseRate',
					}, {
						title: this.$tt('充电电量'),
						key: 'ChargeKwh',
					}, {
						title: this.$tt('充电时长'),
						key: 'ChargeDuration',
					}, {
						title: this.$tt('订单数量'),
						key: 'OrderCount',
					}, {
						title: this.$tt('设备数量'),
						key: 'EquipmentCount',
					}, {
						title: this.$tt('总功率'),
						key: 'TotolPower',
					},
					// {
					// 	title: '操作',
					// 	key: 'action',
					// 	align: 'center',
					// 	render: (h, params) => {
					// 		return h('div', [
					// 			h('Button', {
					// 				props: {
					// 					type: 'primary',
					// 					size: 'small'
					// 				},
					// 				style: {
					// 					marginRight: '5px'
					// 				},
					// 				on: {
					// 					click: () => {
					// 						this.show('view', params.row)
					// 					}
					// 				}
					// 			}, this.$tt('查看')),
					// 			h('Button', {
					// 				props: {
					// 					type: 'primary',
					// 					size: 'small'
					// 				},
					// 				style: {
					// 					marginRight: '5px'
					// 				},
					// 				on: {
					// 					click: () => {
					// 						this.show('up', params.row)
					// 					}
					// 				}
					// 			}, this.$tt('修改')),
					// 		]);
					// 	}
					// }
				],
				data: [],
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			//删除修改之外的其他操作
			otherMethod: function(Id) {
				this.$axios.post(webapi.base_api_url + "/Archives/PushEvent", {
					Id: Id,
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(this.$tt('事件Id') + Id + this.$tt('推送成功'));
						this.handleSubmit();
					}
				})
			},

			/******************组件固定方法*************************/
			show: function(type, params) {
				this.$refs.ItemModal.show(type, params)
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
